module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"weWillContactYouSoon":"Entraremos em contato em breve!"},"en":{"weWillContactYouSoon":"We will contact you soon!"}}')
  delete Component.options._Ctor
}
